<template>
  <div class="cash">
    <div class="title"><span>{{ resultInfo[field] }}</span>{{ title }}</div>
    <div class="tips">{{ tips }}</div>
  </div>
</template>
<script>
export default {
  name: 'Cash',
  props: {
    resultInfo: {
      type: Object,
      default: () => {},
    },
    prizeType: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    title() {
      if (this.prizeType === 7) {
        return '元现金放入您的返现账户';
      }
      return '个骑士币已放入您的账户';
    },
    tips() {
      if (this.prizeType === 7) {
        return '返现红包可提现至零钱或用于骑士商城消费';
      }
      return '骑士币可在骑士商城、充值等消费场景使用';
    },
    field() {
      if (this.prizeType === 7) {
        return 'rewardAmount';
      }
      return 'coinAmount';
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../scale.scss';
.cash {
  width: 574px * $scale;
  height: 164px * $scale;
  margin: 34px * $scale 27px * $scale 38px * $scale 29px * $scale;
  background: url('https://imgcdn.chuxingyouhui.com/blackunique/upload/222080ed154756c918cf90dbd7120552.png') center center no-repeat;
  background-size: contain;
  text-align: center;
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 40px * $scale;
    font-size: 28px * $scale;
    line-height: 44px * $scale;
    font-weight: 500;
    span {
      margin-right: 3px * $scale;
      font-size: 44px * $scale;
      line-height: 56px * $scale;
      color: #985000;
    }
  }
  .tips {
    margin-top: 14px * $scale;
    font-size: 24px * $scale;
    line-height: 24px * $scale;
    color: #999;
  }
}
</style>
